module.exports = __webpack_public_path__ + "static/img/step-0.f302796.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/step-0.png
// module id = RRGN
// module chunks = 1